module.exports = __webpack_public_path__ + "img/en-mb-banner.e35d2899.png";